// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"7df0fa95","583":"94e8f00a","833":"4cab0693","910":"28e6b283"}[chunkId] + ".chunk.js";
};